module.exports = __webpack_public_path__ + "media/application/images/2018/2018-rating-lock-black-673fa5095af5ecd14b88433c9cc330a5.svg";